rdefine('app/products/properties/latlon',['backbone','text!products/prop/latlng.html','app/products/collections/Locations'],function(Backbone,template,Locations) {
    var OptionView = Backbone.Ribs.View.extend({
        tagName:'option',
        bindings:{
            el: {
                text: 'model.name',
                attr: {
                    value: 'model.name'
                }
            }
        }
    });
    return Backbone.Ribs.View.extend({
        map:null,
        geocoder:null,
        marker:null,
        loadedLatLon:null,
        prevGeoCodeTimer:null,
        prevTimeout:null,
        bindings:{
            'select[name=location_id]':{
                value:{
                    data: 'pmodel.location_id',
                    events:'change keyup'
                },
                collection:{
                    col:'locations',
                    view:OptionView
                }
            },
            'input[name=zipcode]':{
                value:{
                    data: 'pmodel.zipcode',
                    events:'change keyup'
                }
            },
            'input[name=city]':{
                value:{
                    data: 'pmodel.city',
                    events:'change keyup'
                }
            },
            'input[name=street]':{
                value:{
                    data: 'pmodel.street',
                    events:'change keyup'
                }
            },
            'input[name=housenumber]':{
                value:{
                    data: 'pmodel.housenumber',
                    events:'change keyup'
                }
            },
            'input[name=branch]':{
                value:{
                    data: 'pmodel.branch',
                    events:'change keyup'
                }
            },
            'input[name=phone]':{
                value:{
                    data: 'pmodel.phone',
                    events:'change keyup'
                }
            }
        },
        initialize:function(options) {
            this.locations = new Locations();
            this.cform = options.cform;
            this.field = 'property_'+this.model.get("id");
            this.pmodel = new Backbone.Ribs.Model(this.cform.get(this.field));
            this.pmodel.on("change",function(){
                this.cform.set(this.field,this.pmodel.attributes);
            }.bind(this));
            this.cform.on("change:"+this.field,function(){
                this.pmodel.set(this.cform.get(this.field));
            }.bind(this));
            this.$el.html(Template7.compile(template)());
            setTimeout(function(){
                this.$el.find("input[name=city]").on("keyup",this.debounceFunction.bind(this));
                this.$el.find("input[name=street]").on("keyup",this.debounceFunction.bind(this));
                this.$el.find("input[name=housenumber]").on("keyup",this.debounceFunction.bind(this));

                this.geocoder = new google.maps.Geocoder();

                var uluru = this.loadedLatLon?this.loadedLatLon:{lat: -25.363, lng: 131.044};


                this.map = new google.maps.Map(this.$el.find('.google_map')[0], {
                    zoom: this.loadedLatLon?14:4,
                    center: uluru
                });

                this.marker = new google.maps.Marker({
                    map: this.map,
                    position: this.map.getCenter()
                });

                this.map.addListener('drag', this.backGeoCode.bind(this));

                if(this.loadedLatLon) {
                    this.codeAddress();
                }
                this.UpdateLatLon();
            }.bind(this),0);
        },
        debounceFunction:function() {
            clearTimeout(this.prevTimeout);
            this.prevTimeout=setTimeout(this.codeAddress.bind(this),300);
        },
        UpdateLatLon:function() {
            var center=this.map.getCenter();
            this.pmodel.set({'lat':center.lat(),'lng':center.lng()});
        },
        backGeoCode:function () {
            if(this.marker) {
                this.marker.setPosition(this.map.getCenter());
                clearTimeout(this.prevGeoCodeTimer);
                this.prevGeoCodeTimer = setTimeout(this.backGeoCodeReal.bind(this),300);
            }else{
                this.marker = new google.maps.Marker({
                    map: this.map,
                    position: this.map.getCenter()
                });

                clearTimeout(this.prevGeoCodeTimer);
                this.prevGeoCodeTimer = setTimeout(this.backGeoCodeReal.bind(this),300);
            }
        },
        backGeoCodeReal:function() {
            this.UpdateLatLon(this.map.getCenter());

            this.geocoder.geocode( { 'location': this.map.getCenter()}, function(results, status) {
                if (status === 'OK') {
                    if(results.length) {
                        var result=results[0];
                        for(var i=0;i<result.address_components.length;i++) {
                            var adress_component=result.address_components[i];

                            if(adress_component.types.indexOf("postal_code")!==-1) {
                                this.pmodel.set('zipcode',adress_component.long_name);
                            }

                            if(adress_component.types.indexOf("locality")!==-1) {
                                this.pmodel.set('city',adress_component.long_name);
                            }

                            if(adress_component.types.indexOf("route")!==-1) {
                                this.pmodel.set('street',adress_component.long_name);
                            }

                            if(adress_component.types.indexOf("street_number")!=-1) {
                                this.pmodel.set('housenumber',adress_component.long_name);
                            }
                            this.UpdateLatLon(this.map.getCenter());
                        }
                    }
                }
            }.bind(this));
        },
        codeAddress:function() {
            var address="";

            var country=this.$el.find("select[name=location_id] option[selected]").text();
            address=country;
            var city = this.pmodel.get("city") || "";
            var street = this.pmodel.get("street","") || "";
            var housenumber = this.pmodel.get("housenumber","") || "";
            address+=city.length?", "+city:"";
            address+=street.length?", "+street:"";
            address+=housenumber.length?", "+housenumber:"";

            this.geocoder.geocode( { 'address': address}, function(results, status) {
                if (status ==='OK') {
                    this.map.setCenter(results[0].geometry.location);
                    this.UpdateLatLon();
                    if(this.marker ) {
                        this.marker.setMap(null);
                    }
                    this.map.fitBounds(results[0].geometry.viewport);
                    this.marker = new google.maps.Marker({
                        map: this.map,
                        position: results[0].geometry.location
                    });
                   this.marker.setAnimation( google.maps.Animation.DROP );
                } else {
                    //alert('Geocode was not successful for the following reason: ' + status);
                }
            }.bind(this));
        }
    });
});